import { getAxiosInstance } from '../../react/utils/networkUtil';
import { AppSuccess } from '../models/AppSuccess';
import FormData from 'form-data';
// #region create upload task
import { PaginationQuery, PaginationResult } from '../models/AppPagination';
import { UploadTask_Base, UploadTask_Metadata } from '../models/UploadTask';
import { AxiosProgressEvent } from 'axios';

// #region create upload task
export interface UploadTask_Create_Request {
  title: string;
  description?: string;
  metadata?: UploadTask_Metadata;
  files: any[];
  project_id?: number;
}
/**
 * User upload file to create a upload task
 */
export const remote_createUploadTask = async (
  request: UploadTask_Create_Request,
  onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
): Promise<AppSuccess<UploadTask_Base>> => {
  const formData = new FormData();
  request.files.forEach((file) => {
    formData.append('files', file);
  });
  formData.append('title', request.title);
  if (request.description) {
    formData.append('description', request.description);
  }
  if (request.metadata) {
    formData.append('metadata', JSON.stringify(request.metadata));
  }
  if (request.project_id) {
    formData.append('project_id', request.project_id);
  }

  return (
    await getAxiosInstance().post('api/upload-task', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    })
  ).data;
};

// #endregion

// #region get page
export interface UploadTask_GetPage_RequestQuery extends PaginationQuery {
  id?: number;
  phone_number?: string;
  project_id?: number;
}
export interface UploadTask_GetPage_Response extends PaginationResult<UploadTask_Base> {}
/**
 * Get a page of upload tasks
 */
export const remote_getPageUploadTasks = async (
  query: UploadTask_GetPage_RequestQuery,
): Promise<UploadTask_GetPage_Response> => {
  return (await getAxiosInstance().get(`api/upload-task`, { params: query })).data;
};
// #endregion

// #region get one
/**
 * Get a upload task by id
 */
export const remote_getOneUploadTask = async (id: number) => {
  return (await getAxiosInstance().get(`api/upload-task/${id}`)).data;
};
// #endregion

// #region update
/**
 * Update a upload task by id
 */
export interface UploadTask_Update_Request {
  title?: string;
  description?: string;
  metadata?: string;
}
export const remote_updateUploadTask = async (id: number, data: UploadTask_Update_Request) => {
  return (await getAxiosInstance().put(`api/upload-task/${id}`, data)).data;
};
// #endregion

// #region delete
/**
 * Delete a upload task by id
 */
export const remote_deleteUploadTask = async (id: number) => {
  return (await getAxiosInstance().delete(`api/upload-task/${id}`)).data;
};
// #endregion

// #region get input files
export interface UploadTask_InputFile {
  name: string;
  size: number;
  isDirectory: boolean;
  mtime: string;
}

export interface UploadTask_GetInputFiles_Response {
  files: UploadTask_InputFile[];
}

/**
 * Get input files of an upload task
 */
export const remote_getInputFiles = async (id: number): Promise<UploadTask_GetInputFiles_Response> => {
  return (await getAxiosInstance().get(`api/upload-task/${id}/input-files`)).data;
};
// #endregion

// #region download input file
/**
 * Get download URL for an input file
 * Returns the URL string that can be used with StreamSaver or other download methods
 */
export const getInputFileDownloadUrl = (id: number, fileName: string): string => {
  const axiosInstance = getAxiosInstance();
  const baseURL = axiosInstance.defaults.baseURL || '';
  return `${baseURL}/api/upload-task/${id}/input-files/${encodeURIComponent(fileName)}`;
};
// #endregion

export const UploadTaskAPIs = {
  remote_createUploadTask,
  remote_getPageUploadTasks,
  remote_getOneUploadTask,
  remote_updateUploadTask,
  remote_deleteUploadTask,
  remote_getInputFiles,
  getInputFileDownloadUrl,
};
